import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import Constants from './marketing-nav-bar/top-bar-data';
import ProductsDropdown from './marketing-nav-bar/products-dropdown';

// Arrow icon for the CTA button
const ArrowIcon = () => (
  <svg
    className="nav-bar-button__arrow"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 11.75H17M11.75 5.25L18 11.75L11.75 18.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

// Chevron icon for dropdown
const ChevronIcon = ({ isOpen }) => (
  <svg
    className={classNames('nav-bar-chevron', {
      'nav-bar-chevron--open': isOpen,
    })}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 4.5L6 8L9.5 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ChevronIcon.propTypes = {
  isOpen: PropTypes.bool,
};

// Hamburger menu icon
const MenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6H21M3 12H21M3 18H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// Close icon for mobile menu
const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6L18 18M6 18L18 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const TopBarMenu = createReactClass({
  propTypes: {
    topBarMenuLinkData: PropTypes.array,
    dropDownMenuLinkData: PropTypes.array,
    pageToHighLight: PropTypes.string,
    useWhite: PropTypes.bool,
    useBlack: PropTypes.bool,
    isCompact: PropTypes.bool,
    isLogInButtonVisible: PropTypes.bool,
    isSignUpButtonVisible: PropTypes.bool,
    googleSignInClientId: PropTypes.string,
    loginEmailAddress: PropTypes.string,
    loginDropDownMenuLinkData: PropTypes.array,
    signupTargetUrl: PropTypes.string,
    useRegularLink: PropTypes.bool,
    loginHeaderText: PropTypes.string,
    hideDropDownMenu: PropTypes.bool,
    recoverPasswordForm: PropTypes.object,
    loginForm: PropTypes.object,
    signupForm: PropTypes.object,
    intl: PropTypes.object,
  },

  getInitialState() {
    return {
      productsDropdownOpen: false,
      mobileMenuOpen: false,
    };
  },

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
  },

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
    window.removeEventListener('resize', this.handleResize);
  },

  handleResize() {
    // Close mobile menu on resize to desktop
    if (
      window.innerWidth >= Constants.topBarScreenThreshhold &&
      this.state.mobileMenuOpen
    ) {
      this.setState({ mobileMenuOpen: false });
      document.body.style.overflow = '';
    }
  },

  handleClickOutside(evt) {
    if (
      this.productsRef &&
      !this.productsRef.contains(evt.target) &&
      this.state.productsDropdownOpen
    ) {
      this.setState({ productsDropdownOpen: false });
      this.hideOverlay();
    }
  },

  isMobileScreen() {
    return window.innerWidth < Constants.topBarScreenThreshhold;
  },

  showOverlay() {
    const overlay = document.getElementById('fn-overlay-blur-background');
    if (overlay) {
      overlay.classList.add('fn-overlay-show');
    }
  },

  hideOverlay() {
    const overlay = document.getElementById('fn-overlay-blur-background');
    if (overlay) {
      overlay.classList.remove('fn-overlay-show');
    }
  },

  toggleProductsDropdown() {
    const isOpen = !this.state.productsDropdownOpen;
    this.setState({ productsDropdownOpen: isOpen });
    if (isOpen && !this.state.mobileMenuOpen) {
      this.showOverlay();
    } else if (!isOpen) {
      this.hideOverlay();
    }
  },

  toggleMobileMenu() {
    const isOpen = !this.state.mobileMenuOpen;
    this.setState({
      mobileMenuOpen: isOpen,
      productsDropdownOpen: false,
    });
    // Prevent body scroll when mobile menu is open
    document.body.style.overflow = isOpen ? 'hidden' : '';
  },

  render() {
    const { productsDropdown, navLinks, buttons, loginUrl, signupUrl } =
      Constants;

    return (
      <div className="navbar2">
        {/* Desktop Navigation */}
        <nav className="navbar2__menu navbar2__menu--desktop">
          {/* Products Dropdown */}
          <div
            className={classNames('navbar2__dropdown', {
              'navbar2__dropdown--open': this.state.productsDropdownOpen,
            })}
            ref={(ref) => {
              this.productsRef = ref;
            }}
          >
            <button
              className="navbar2__dropdown-toggle"
              onClick={this.toggleProductsDropdown}
              aria-expanded={this.state.productsDropdownOpen}
              aria-haspopup="menu"
              type="button"
            >
              <span>{productsDropdown.text}</span>
              <ChevronIcon isOpen={this.state.productsDropdownOpen} />
            </button>
            <ProductsDropdown
              isOpen={this.state.productsDropdownOpen}
              daCategory={productsDropdown.daCategory}
            />
          </div>

          {/* Navigation Links */}
          {navLinks.map((link) => (
            <a
              key={link.key}
              className="navbar2__link"
              href={link.url}
              da-category={link.daCategory}
              da-action={link.daAction}
            >
              {link.text}
            </a>
          ))}
        </nav>

        {/* Right side buttons */}
        <div className="navbar2__right">
          {/* Log in Button - Desktop */}
          {this.props.isLogInButtonVisible && (
            <a
              className="navbar2__button navbar2__button--outline navbar2__button--desktop"
              href={loginUrl}
              da-category="login"
              da-action="login"
            >
              {buttons.logIn}
            </a>
          )}

          {/* Fax for free CTA Button */}
          {this.props.isSignUpButtonVisible && (
            <a
              className="navbar2__button navbar2__button--primary"
              href={signupUrl}
              da-category="signup"
              da-action="fax for free"
              data-qa-ref="sign-up"
            >
              <span>{buttons.faxForFree}</span>
              <ArrowIcon />
            </a>
          )}

          {/* Mobile Menu Button */}
          <button
            className="navbar2__menu-button"
            onClick={this.toggleMobileMenu}
            aria-label="menu"
            aria-expanded={this.state.mobileMenuOpen}
            type="button"
          >
            {this.state.mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav
          className={classNames('navbar2__menu navbar2__menu--mobile', {
            'navbar2__menu--mobile-open': this.state.mobileMenuOpen,
          })}
        >
          {/* Products Dropdown - Mobile */}
          <div className="navbar2__mobile-item">
            <button
              className="navbar2__mobile-toggle"
              onClick={this.toggleProductsDropdown}
              aria-expanded={this.state.productsDropdownOpen}
              type="button"
            >
              <span>{productsDropdown.text}</span>
              <ChevronIcon isOpen={this.state.productsDropdownOpen} />
            </button>
            <ProductsDropdown
              isOpen={this.state.productsDropdownOpen}
              daCategory={productsDropdown.daCategory}
            />
          </div>

          {/* Navigation Links - Mobile */}
          {navLinks.map((link) => (
            <a
              key={link.key}
              className="navbar2__mobile-link"
              href={link.url}
              da-category={link.daCategory}
              da-action={link.daAction}
            >
              {link.text}
            </a>
          ))}

          {/* Mobile buttons */}
          <div className="navbar2__mobile-buttons">
            {this.props.isLogInButtonVisible && (
              <a
                className="navbar2__button navbar2__button--outline"
                href={loginUrl}
                da-category="login"
                da-action="login"
              >
                {buttons.logIn}
              </a>
            )}
          </div>
        </nav>
      </div>
    );
  },
});

export default injectIntl(TopBarMenu);
